import React, { Component } from "react";
import LayoutWrapper from "./LayoutWrapper";
import { Switch, message } from "antd";
import "./maintenancetracker.scss";

export class MaintenanceTracker extends Component {
  constructor(props) {
    super(props);
    props.initialconstruct && props.initialconstruct.bind(this)("MaintenanceTracker");

    this.state = {
      categories: [],
      addingNew: false,
      newCategoryName: "",
      loader: false,
      priorities: [],
      loadingPriorities: false,
      savingPriorities: false,
      addingNewPriority: false,
      newPriorityName: "",
      newPriorityDays: "",
      creatingPriority: false,
    };
  }

  componentDidMount() {
    this.fetchIssueCategories();
    this.fetchIssuePriorities();
  }

  fetchIssueCategories = () => {
    this.setState({ loader: true });

    const processCategories = (res) => {
      let rawList = [];
      if (res && res.data) {
        if (Array.isArray(res.data)) rawList = res.data;
        else if (Array.isArray(res.data.data)) rawList = res.data.data;
        else if (Array.isArray(res.data.records)) rawList = res.data.records;
        else if (Array.isArray(res.data.categories)) rawList = res.data.categories;
        else if (Array.isArray(res.data.issueCategories)) rawList = res.data.issueCategories;
      } else if (Array.isArray(res)) {
        rawList = res;
      } else if (res && typeof res === 'object') {
        if (Array.isArray(res.records)) rawList = res.records;
        else if (Array.isArray(res.categories)) rawList = res.categories;
        else if (Array.isArray(res.data)) rawList = res.data;
      }

      if (rawList && rawList.length > 0) {
        const categories = rawList.map((item, index) => ({
          id: item.issueCategoryId || item._id || index,
          issueCategoryId: item.issueCategoryId || item._id,
          name: item.name || item.category_name || item.categoryName || 'Category',
          active: item.isActive !== undefined ? item.isActive : true,
          editing: false
        }));
        this.setState({ categories, loader: false });
        return true;
      }
      this.setState({ loader: false });
      return false;
    };

    const apiCall =
      this.props.api?.apiGetIssueCategories ||
      this.api?.apiGetIssueCategories ||
      window.app?.props?.api?.apiGetIssueCategories;

    if (apiCall) {
      apiCall({})
        .then((res) => {
          const success = processCategories(res);
          if (!success) this.fetchCategoriesDirectly(processCategories);
        })
        .catch(() => this.fetchCategoriesDirectly(processCategories));
    } else {
      this.fetchCategoriesDirectly(processCategories);
    }
  };

  fetchCategoriesDirectly = (processCategories) => {
    const token =
      window.store?.getState()?.root?.auth ||
      localStorage.getItem('token') ||
      localStorage.getItem('auth') ||
      '';
    const apiBase =
      window.envconfig?.[window.environment]?.api_base ||
      window.axios?.defaults?.baseURL ||
      '';

    const headers = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    };

    fetch(`${apiBase}/api/v1/issue-tracker/issue-category`, { method: 'GET', headers })
      .then((r) => r.json())
      .then((res) => {
        const success = processCategories(res);
        if (!success) {
          this.setState({ loader: false });
        }
      })
      .catch((err) => {
        console.error("Error fetching issue categories directly", err);
        this.setState({ loader: false });
      });
  };

  fetchIssuePriorities = () => {
    this.setState({ loadingPriorities: true });

    const processPriorities = (res) => {
      let rawList = [];
      if (res && res.data) {
        if (Array.isArray(res.data)) rawList = res.data;
        else if (Array.isArray(res.data.data)) rawList = res.data.data;
        else if (Array.isArray(res.data.records)) rawList = res.data.records;
        else if (Array.isArray(res.data.priorities)) rawList = res.data.priorities;
      } else if (Array.isArray(res)) {
        rawList = res;
      } else if (res && typeof res === 'object') {
        if (Array.isArray(res.records)) rawList = res.records;
        else if (Array.isArray(res.data)) rawList = res.data;
        else if (Array.isArray(res.priorities)) rawList = res.priorities;
      }

      if (rawList && rawList.length > 0) {
        const priorities = rawList.map((item, index) => ({
          id: item.issuePriorityId || item._id || index,
          issuePriorityId: item.issuePriorityId || item._id,
          name: item.name || `P${index}`,
          days: item.days !== undefined ? item.days : 4,
          _id: item._id
        }));
        this.setState({ priorities, loadingPriorities: false });
        return true;
      }
      this.setState({ loadingPriorities: false });
      return false;
    };

    const apiCall =
      this.props.api?.apiGetIssuePriorities ||
      this.api?.apiGetIssuePriorities ||
      window.app?.props?.api?.apiGetIssuePriorities;

    if (apiCall) {
      apiCall({})
        .then((res) => {
          const success = processPriorities(res);
          if (!success) this.fetchPrioritiesDirectly(processPriorities);
        })
        .catch(() => this.fetchPrioritiesDirectly(processPriorities));
    } else {
      this.fetchPrioritiesDirectly(processPriorities);
    }
  };

  fetchPrioritiesDirectly = (processPriorities) => {
    const token =
      window.store?.getState()?.root?.auth ||
      localStorage.getItem('token') ||
      localStorage.getItem('auth') ||
      '';
    const apiBase =
      window.envconfig?.[window.environment]?.api_base ||
      window.axios?.defaults?.baseURL ||
      '';

    const headers = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    };

    fetch(`${apiBase}/api/v1/issue-tracker/issue-priority`, { method: 'GET', headers })
      .then((r) => r.json())
      .then((res) => {
        const success = processPriorities(res);
        if (!success) {
          this.setState({
            priorities: [
              { id: "P0", issuePriorityId: "", name: "P0", days: 4 },
              { id: "P1", issuePriorityId: "", name: "P1", days: 4 },
              { id: "P2", issuePriorityId: "", name: "P2", days: 4 },
            ],
            loadingPriorities: false,
          });
        }
      })
      .catch((err) => {
        console.error("Error fetching issue priorities directly", err);
        this.setState({
          priorities: [
            { id: "P0", issuePriorityId: "", name: "P0", days: 4 },
            { id: "P1", issuePriorityId: "", name: "P1", days: 4 },
            { id: "P2", issuePriorityId: "", name: "P2", days: 4 },
          ],
          loadingPriorities: false,
        });
      });
  };

  toggleAdd = () => {
    this.setState({ 
      addingNew: !this.state.addingNew, 
      newCategoryName: "",
      categories: this.state.categories.map(c => ({ ...c, editing: false }))
    });
  };

  handleNewCategoryChange = (e) => {
    this.setState({ newCategoryName: e.target.value });
  };

  submitNewCategory = () => {
    const { newCategoryName } = this.state;
    if (newCategoryName.trim()) {
      if (this.props.api && this.props.api.apiCreateIssueCategory) {
        this.props.api
          .apiCreateIssueCategory({ name: newCategoryName.trim() })
          .then((res) => {
            if (window.success) window.success("Category created successfully");
            this.setState({ addingNew: false, newCategoryName: "" });
            this.fetchIssueCategories();
          })
          .catch((err) => {
            if (window.error) window.error(err?.message || "Failed to create category");
            console.error("Error creating category", err);
          });
      }
    }
  };

  toggleEdit = (id) => {
    this.setState({
      addingNew: false,
      categories: this.state.categories.map(c =>
        c.id === id ? { ...c, editing: !c.editing } : c
      )
    });
  };

  handleCategoryChange = (id, newName) => {
    this.setState({
      categories: this.state.categories.map(c =>
        c.id === id ? { ...c, name: newName } : c
      )
    });
  };

  updateCategory = (cat) => {
    if (cat && cat.name && cat.name.trim()) {
      const issueCategoryId = cat.issueCategoryId || cat.id;
      if (this.props.api && this.props.api.apiUpdateIssueCategory) {
        this.props.api
          .apiUpdateIssueCategory({ name: cat.name.trim() }, { issueCategoryId })
          .then((res) => {
            if (window.success) window.success("Category updated successfully");
            this.setState({
              categories: this.state.categories.map(c =>
                (c.id === cat.id || c.issueCategoryId === issueCategoryId) ? { ...c, editing: false } : c
              )
            });
            this.fetchIssueCategories();
          })
          .catch((err) => {
            if (window.error) window.error(err?.message || "Failed to update category");
            console.error("Error updating category", err);
          });
      }
    }
  };

  toggleActive = (cat, checked) => {
    const issueCategoryId = cat.issueCategoryId || cat.id;
    if (this.props.api && this.props.api.apiPatchIssueCategory) {
      this.props.api
        .apiPatchIssueCategory({}, { issueCategoryId })
        .then((res) => {
          if (window.success) window.success(`Category ${checked ? 'activated' : 'deactivated'} successfully`);
          this.setState({
            categories: this.state.categories.map(c =>
              (c.id === cat.id || c.issueCategoryId === issueCategoryId) ? { ...c, active: checked } : c
            )
          });
        })
        .catch((err) => {
          if (window.error) window.error(err?.message || "Failed to toggle status");
          console.error("Error toggling active status", err);
          this.setState({
            categories: this.state.categories.map(c =>
              (c.id === cat.id || c.issueCategoryId === issueCategoryId) ? { ...c, active: !checked } : c
            )
          });
        });
    } else {
      this.setState({
        categories: this.state.categories.map(c =>
          c.id === cat.id ? { ...c, active: checked } : c
        )
      });
    }
  };

  toggleAddPriority = () => {
    this.setState({
      addingNewPriority: !this.state.addingNewPriority,
      newPriorityName: "",
      newPriorityDays: "",
    });
  };

  handleNewPriorityNameChange = (e) => {
    this.setState({ newPriorityName: e.target.value });
  };

  handleNewPriorityDaysChange = (e) => {
    this.setState({ newPriorityDays: e.target.value });
  };

  submitNewPriority = () => {
    const { newPriorityName, newPriorityDays } = this.state;
    if (!newPriorityName.trim()) {
      if (window.error) window.error("Please enter priority name");
      else if (message?.error) message.error("Please enter priority name");
      return;
    }
    const days = newPriorityDays !== "" ? Number(newPriorityDays) : 0;
    if (isNaN(days) || days < 0) {
      if (window.error) window.error("Please enter valid days");
      else if (message?.error) message.error("Please enter valid days");
      return;
    }

    this.setState({ creatingPriority: true });

    const payload = {
      name: newPriorityName.trim(),
      days: days,
    };

    const apiCall =
      this.props.api?.apiCreateIssuePriority ||
      this.api?.apiCreateIssuePriority ||
      window.app?.props?.api?.apiCreateIssuePriority;

    if (apiCall) {
      apiCall(payload)
        .then(() => {
          this.setState({ creatingPriority: false, addingNewPriority: false, newPriorityName: "", newPriorityDays: "" });
          if (window.success) window.success("Priority created successfully");
          else if (message?.success) message.success("Priority created successfully");
          this.fetchIssuePriorities();
        })
        .catch(() => {
          this.createPriorityDirectly(payload);
        });
    } else {
      this.createPriorityDirectly(payload);
    }
  };

  createPriorityDirectly = (payload) => {
    const token =
      window.store?.getState()?.root?.auth ||
      localStorage.getItem('token') ||
      localStorage.getItem('auth') ||
      '';
    const apiBase =
      window.envconfig?.[window.environment]?.api_base ||
      window.axios?.defaults?.baseURL ||
      '';

    const headers = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    };

    fetch(`${apiBase}/api/v1/issue-tracker/issue-priority`, {
      method: 'POST',
      headers,
      body: JSON.stringify(payload),
    })
      .then((r) => r.json())
      .then((res) => {
        this.setState({ creatingPriority: false, addingNewPriority: false, newPriorityName: "", newPriorityDays: "" });
        if (window.success) window.success("Priority created successfully");
        else if (message?.success) message.success("Priority created successfully");
        this.fetchIssuePriorities();
      })
      .catch((err) => {
        this.setState({ creatingPriority: false });
        if (window.error) window.error(err?.message || "Failed to create priority");
        else if (message?.error) message.error(err?.message || "Failed to create priority");
        console.error("Error creating priority directly", err);
      });
  };

  handlePriorityChange = (id, newDays) => {
    this.setState({
      priorities: this.state.priorities.map(p =>
        p.id === id ? { ...p, days: newDays === "" ? "" : Number(newDays) } : p
      )
    });
  };

  submitUpdatePriorities = () => {
    const { priorities } = this.state;
    this.setState({ savingPriorities: true });

    const payload = priorities
      .filter((p) => p.issuePriorityId || p._id || p.id)
      .map((p) => ({
        issuePriorityId: p.issuePriorityId || p._id || p.id,
        days: Number(p.days) || 0,
      }));

    const apiUpdateCall = this.props.api?.apiUpdateIssuePriority || this.api?.apiUpdateIssuePriority;

    if (apiUpdateCall) {
      apiUpdateCall(payload)
        .then(() => {
          this.setState({ savingPriorities: false });
          if (window.success) window.success("Priorities updated successfully");
          else if (message?.success) message.success("Priorities updated successfully");
          this.fetchIssuePriorities();
        })
        .catch(() => {
          this.updatePrioritiesDirectly(payload);
        });
    } else {
      this.updatePrioritiesDirectly(payload);
    }
  };

  updatePrioritiesDirectly = (payload) => {
    const token =
      window.store?.getState()?.root?.auth ||
      localStorage.getItem('token') ||
      localStorage.getItem('auth') ||
      '';
    const apiBase =
      window.envconfig?.[window.environment]?.api_base ||
      window.axios?.defaults?.baseURL ||
      '';
    const headers = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    };

    fetch(`${apiBase}/api/v1/issue-tracker/issue-priority`, {
      method: 'PUT',
      headers,
      body: JSON.stringify(payload),
    })
      .then((r) => r.json())
      .then(() => {
        this.setState({ savingPriorities: false });
        if (window.success) window.success("Priorities updated successfully");
        else if (message?.success) message.success("Priorities updated successfully");
        this.fetchIssuePriorities();
      })
      .catch((err) => {
        this.setState({ savingPriorities: false });
        if (window.error) window.error(err?.message || "Failed to update priorities");
        else if (message?.error) message.error(err?.message || "Failed to update priorities");
        console.error("Error updating priorities directly", err);
      });
  };

  render() {
    const {
      categories,
      addingNew,
      newCategoryName,
      priorities,
      loadingPriorities,
      savingPriorities,
      addingNewPriority,
      newPriorityName,
      newPriorityDays,
      creatingPriority
    } = this.state;
    const isAnyEditing = categories.some(c => c.editing);

    return (
      <LayoutWrapper title="Maintenance Tracker" className=" maintenance-tracker">
        <div className="row">
          {/* Issue Categories Card */}
          <div className="col-md-6 mb-4">
            <div className="card h-100 maintenance-tracker-card">
              <div className="card-header d-flex justify-content-between align-items-center" style={{ backgroundColor: '#fff2e6', borderTopLeftRadius: '10px', borderTopRightRadius: '10px', borderBottom: 'none', padding: '15px 20px' }}>
                <h5 className="mb-0" style={{ fontWeight: '600', fontSize: '15px' }}>Issue Categories</h5>
                {!isAnyEditing && (
                  <span style={{ color: addingNew ? '#dc3545' : '#f39c12', cursor: 'pointer', fontWeight: '500' }} onClick={this.toggleAdd}>
                    {addingNew ? 'x Cancel' : '+ Add'}
                  </span>
                )}
              </div>
              <div className="card-body" style={{ padding: '20px' }}>
                <ul className="list-group list-group-flush">
                  {categories.map((cat, index) => (
                    <li key={cat.id} className="list-group-item d-flex justify-content-between align-items-center" style={{ border: 'none', padding: '10px 0', borderBottom: index < categories.length - 1 ? '1px solid #f0f0f0' : 'none' }}>
                      {cat.editing ? (
                        <input
                          type="text"
                          className="form-control"
                          style={{ maxWidth: '200px' }}
                          value={cat.name}
                          onChange={(e) => this.handleCategoryChange(cat.id, e.target.value)}
                        />
                      ) : (
                        <span style={{ fontSize: '14px', color: '#555' }}>{cat.name}</span>
                      )}

                      <div>
                        <i
                          className="la la-pencil"
                          style={{ cursor: 'pointer', color: '#888', marginRight: '15px', fontSize: '16px' }}
                          onClick={() => this.toggleEdit(cat.id)}
                        ></i>
                        <Switch
                          size="small"
                          checked={cat.active}
                          onChange={(checked) => this.toggleActive(cat, checked)}
                          style={{ backgroundColor: cat.active ? '#f39c12' : '#ccc' }}
                        />
                      </div>
                    </li>
                  ))}
                </ul>

                {addingNew && (
                  <div className="mt-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Please enter category name"
                      value={newCategoryName}
                      onChange={this.handleNewCategoryChange}
                      style={{ borderRadius: '5px' }}
                    />
                  </div>
                )}

                {(addingNew || isAnyEditing) && (
                  <div className="mt-4">
                    <button
                      className="btn w-100"
                      style={{ backgroundColor: '#f39c12', color: 'white', fontWeight: 'bold', borderRadius: '20px' }}
                      onClick={
                        addingNew
                          ? this.submitNewCategory
                          : () => {
                              const editingCat = categories.find(c => c.editing);
                              if (editingCat) {
                                this.updateCategory(editingCat);
                              }
                            }
                      }
                    >
                      {addingNew ? 'Submit' : 'Update'}
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Priority P0 to P1 / P2 Response Card */}
          <div className="col-md-6 mb-4">
            <div className="card h-100 maintenance-tracker-card">
              <div className="card-header d-flex justify-content-between align-items-center" style={{ backgroundColor: '#fff2e6', borderTopLeftRadius: '10px', borderTopRightRadius: '10px', borderBottom: 'none', padding: '15px 20px' }}>
                <h5 className="mb-0" style={{ fontWeight: '600', fontSize: '15px' }}>Priority P0 to P1</h5>
                <span style={{ color: addingNewPriority ? '#dc3545' : '#f39c12', cursor: 'pointer', fontWeight: '500' }} onClick={this.toggleAddPriority}>
                  {addingNewPriority ? 'x Cancel' : '+ Add'}
                </span>
              </div>
              <div className="card-body" style={{ padding: '20px' }}>
                {loadingPriorities ? (
                  <div className="text-center py-4">
                    <div className="spinner-border text-warning" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : (
                  <ul className="list-group list-group-flush">
                    {priorities.map((item, index) => (
                      <li key={item.id} className="list-group-item d-flex justify-content-between align-items-center" style={{ border: 'none', padding: '10px 0', borderBottom: index < priorities.length - 1 ? '1px solid #f0f0f0' : 'none' }}>
                        <span style={{ fontSize: '14px', color: '#555', minWidth: '100px', fontWeight: '500' }}>{item.name}</span>
                        <div className="d-flex align-items-center">
                          <input
                            type="number"
                            className="form-control text-right"
                            style={{ width: '75px', height: '30px', padding: '5px 10px', borderRadius: '5px', marginRight: '10px' }}
                            value={item.days}
                            min={0}
                            onChange={(e) => this.handlePriorityChange(item.id, e.target.value)}
                          />
                          <span style={{ fontSize: '14px', color: '#555' }}>Days</span>
                        </div>
                      </li>
                    ))}
                  </ul>
                )}

                {addingNewPriority && (
                  <div className="mt-3 p-3" style={{ backgroundColor: '#fafafa', borderRadius: '8px', border: '1px solid #eee' }}>
                    <div className="row g-2 align-items-center">
                      <div className="col-7">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Priority Name (e.g. P3)"
                          value={newPriorityName}
                          onChange={this.handleNewPriorityNameChange}
                          style={{ borderRadius: '5px', height: '34px', fontSize: '13px' }}
                        />
                      </div>
                      <div className="col-5 d-flex align-items-center">
                        <input
                          type="number"
                          className="form-control text-right"
                          placeholder="Days"
                          value={newPriorityDays}
                          min={0}
                          onChange={this.handleNewPriorityDaysChange}
                          style={{ width: '70px', borderRadius: '5px', height: '34px', fontSize: '13px', marginRight: '8px' }}
                        />
                        <span style={{ fontSize: '13px', color: '#555' }}>Days</span>
                      </div>
                    </div>
                  </div>
                )}

                <div className="mt-4 pt-3">
                  <button
                    className="btn w-100"
                    style={{ backgroundColor: '#f39c12', color: 'white', fontWeight: 'bold', borderRadius: '20px' }}
                    onClick={addingNewPriority ? this.submitNewPriority : this.submitUpdatePriorities}
                    disabled={savingPriorities || loadingPriorities || creatingPriority}
                  >
                    {creatingPriority
                      ? 'Creating...'
                      : addingNewPriority
                      ? 'Submit'
                      : savingPriorities
                      ? 'Updating...'
                      : 'Update'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LayoutWrapper>
    );
  }
}

export default connect(MaintenanceTracker);
